import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M10.938 1.582 10.65 1.5l-.208.212-8.156 8.29-.109.111-.027.153-.625 3.524-.126.71.709-.13 3.466-.636.156-.028.11-.113 8.156-8.29.203-.207-.077-.279c-.202-.728-.615-1.395-1.211-2.001-.597-.606-1.254-1.027-1.975-1.234Zm-7.36 8.535 7.358-7.479c.428.172.85.46 1.262.88.417.423.702.857.872 1.3L5.718 12.29l-2.14-2.174Zm-.54.878-.4 2.26 2.223-.408-1.823-1.852Z",
		clipRule: "evenodd"
	})
});
export default SvgEdit;
